
import HeaderSearch from './HeaderSearch'
import Menu from '~/constants/Menu'

export default {
  components: { HeaderSearch },
  data() {
    return {
      Menu,
      isHover: false,
      activeIdx: -1,
      lnbArrowX: 500,
      headerSearchOpen: false, 
      headerSearchPopStyle: { top: '0px', left: '0px', width: '225px' },
    }
  },
  computed: {
    desktopMenus() {
      return (this.Menu || []).filter((m) => m.mobile === false)
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.onGlobalMouseDown, true)
    window.addEventListener('keydown', this.onGlobalKeydown)
    window.addEventListener('resize', this.repositionHeaderSearch, { passive: true })
    window.addEventListener('scroll', this.repositionHeaderSearch, true)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onGlobalMouseDown, true)
    window.removeEventListener('keydown', this.onGlobalKeydown)
    window.removeEventListener('resize', this.repositionHeaderSearch)
    window.removeEventListener('scroll', this.repositionHeaderSearch, true)
  },
  methods: {
    unwrapEl(refVal) {
      if (!refVal) return null
      const v = Array.isArray(refVal) ? refVal[0] : refVal
      return v && v.$el ? v.$el : v
    },

    openMenu(idx, menu, e) {
      this.activeIdx = idx
      this.isHover = true

      const liRect = e?.currentTarget?.getBoundingClientRect?.()
      const gnbCenterX = liRect ? liRect.left + liRect.width / 2 : null

      this.$nextTick(() => {
        const panelRef = this.$refs[`lnbPanel-${idx}`]
        const panelEl = this.unwrapEl(panelRef)
        if (!panelEl || typeof panelEl.getBoundingClientRect !== 'function' || !gnbCenterX) return

        const panelRect = panelEl.getBoundingClientRect()
        const rawX = gnbCenterX - panelRect.left

        const padding = 24
        const clampedX = Math.max(padding, Math.min(rawX, panelRect.width - padding))
        this.lnbArrowX = clampedX
      })
    },
    hiddenMenu() {
      this.isHover = false
      this.activeIdx = -1
    },
    onClickOpenExternalLink(uri) {
      window.open(uri, '_blank')
      this.hiddenMenu() 
    },
    toggleHeaderSearch() {
      this.headerSearchOpen = !this.headerSearchOpen
      if (this.headerSearchOpen) {
        this.$nextTick(() => {
          this.repositionHeaderSearch()
          const pop = this.$refs.headerSearchPop
          const popEl = this.unwrapEl(pop)
          const input = popEl && popEl.querySelector ? popEl.querySelector('input, textarea') : null
          if (input) input.focus()
        })
      }
    },

    closeHeaderSearch() {
      this.headerSearchOpen = false
    },

    repositionHeaderSearch() {
      if (!this.headerSearchOpen) return

      const btn = this.unwrapEl(this.$refs.headerSearchBtn)
      const pop = this.unwrapEl(this.$refs.headerSearchPop)
      if (!btn || !btn.getBoundingClientRect) return

      const rect = btn.getBoundingClientRect()
      const gap = 10
      const maxW = Math.min(225, window.innerWidth - 16)
      const popH = pop ? pop.offsetHeight : 260
      let left = rect.left - maxW - gap

      if (left < 8) left = Math.min(window.innerWidth - maxW - 8, rect.right + gap)
      let top = rect.top + rect.height / 2 - popH / 2
      top = Math.max(8, Math.min(top, window.innerHeight - popH - 8))
      this.headerSearchPopStyle = {
        top: `${top}px`,
        left: `${left}px`,
        width: `${maxW}px`,
      }
    },

    onGlobalMouseDown(e) {
      if (!this.headerSearchOpen) return
      const pop = this.unwrapEl(this.$refs.headerSearchPop)
      const btn = this.unwrapEl(this.$refs.headerSearchBtn)
      const t = e.target
      if ((pop && pop.contains(t)) || (btn && btn.contains(t))) return
      this.closeHeaderSearch()
    },

    onGlobalKeydown(e) {
      if (!this.headerSearchOpen) return
      if (e.key === 'Escape') this.closeHeaderSearch()
    },
  },
}
